import React from 'react'
import './assets/style.css'
import Header from './components/Header'
import Container from './components/Container'

const App = () => {
  return (
    <div className='wrapper'>
      <Header />
      <Container />
    </div>
  )
}

export default App
